import { takeLatest } from 'redux-saga'
import { put, take, all } from 'redux-saga/effects'
import actionTypes from '../actions/actionTypes'
import { dmStorageExperimentSync } from '../../sync'
import callAny from 'redux/sagas/helpers/call_any'
import dmStorageExperimentActions from 'redux/actions/dm_storage_experiment_actions'
import generalActions from 'redux/actions/generalActions'


function *dmStorageExperimentCompleted() {
	yield callAny(dmStorageExperimentSync.dmStorageExperimentCompleted)
}

function *dmStorageExperimentReferContactClose() {
	try {
		yield callAny(dmStorageExperimentSync.dmStorageExperimentCompleted)
		yield put(dmStorageExperimentActions.referContactCloseSuccess())
	} catch (error) {
		yield put(generalActions.syncUncaughtError(error))
	}
}

function *dmStorageExperimentReferContactSend(action) {
	try {
		yield all([
			callAny(dmStorageExperimentSync.sendEmailToDM, action.firstName, action.lastName, action.email, action.phoneNumber, action.role),
			take(actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_ANIMATION_COMPLETED),
			take(actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_METRICS_SUCCESS),
		])
		yield put(dmStorageExperimentActions.referContactSendSuccess())
	} catch (error) {
		yield put(generalActions.syncUncaughtError(error))
	}
}

export default [
	takeLatest(actionTypes.DM_STORAGE_EXPERIMENT_GO_TO_MY_LIBRARY, dmStorageExperimentCompleted),
	takeLatest(actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE, dmStorageExperimentReferContactClose),
	takeLatest(actionTypes.DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND, dmStorageExperimentReferContactSend),
]


export {
	dmStorageExperimentCompleted,
	dmStorageExperimentReferContactClose,
	dmStorageExperimentReferContactSend,
}
